import { join } from 'ramda';
import { TIncomingMMGRSettings } from './withMMGRSettings.types';
import { Selection } from '../../../constants/Selection';
import { ExternalSource, MainSource } from '../../../constants/Source';
import { Sort } from '../../../constants/Sort';
import { MediaType } from '../../../constants/MediaType';
import { NameSpace } from '../../../constants/NameSpace';
import { WixMediaRoot } from '../../../constants/WixMediaRoot';
import { SettingsLayout } from '../../../constants/Layout';
import { isEditorX } from '../../env/utils';

export const wixComDomain =
  process.env.NODE_ENV === 'development' ? '//local.wix.com:3000' : `https://${location.hostname}`;
export const wixComDomainStatic =
  process.env.NODE_ENV === 'development'
    ? '//local.wix.com:3200'
    : process.env.NODE_ENV === 'production'
    ? `https://${location.hostname}`
    : '';

const wixOrEditorX = isEditorX ? 'editorx.com' : 'wix.com';

export const defaultMMGRSettings: Partial<TIncomingMMGRSettings> = {
  siteMediaToken: null,
  metaSiteToken: null,
  privateMediaRestAPI: `https://files.${wixOrEditorX}`,
  privateMediaRestFiles: 'https://static.wixstatic.com',
  privateMediaRestVideoFiles: 'https://video.wixstatic.com',
  publicMediaRestAPI: `https://publicmedia.${wixOrEditorX}/public`,
  publicMediaRestFiles: 'https://static.wixstatic.com',
  publicMediaRestVideoFiles: 'https://video.wixstatic.com',
  publicCMSDomain: 'https://publicmedia.wix.com',
  unsplashRestAPI: wixComDomain,
  pixAPI: `https://pix.${wixOrEditorX}`,
  createOrderPageDomain: wixComDomain,
  recommendedRestApi: 'https://manage.wix.com',
  recommendedPreferencesRestApi: `https://files.${wixOrEditorX}`,
  recommendedTopicsListApiUrl: 'https://manage.wix.com',
  shutterStockPaymentAPI: `https://pix.${wixOrEditorX}`,
  additionalItemAttributes: ['source', 'tags', 'tagsEn', 'labels', 'vendor', 'creator', 'reference'],
  path: '',
  publicMediaRoot: [WixMediaRoot.Images, WixMediaRoot.Illustrations, WixMediaRoot.VectorArt],
  canShowSelectButton: true,
  canSubmitUntranscoded: false,
  canSubmitTransparentVideos: true,
  uploadItems: true,
  uploadItemsOpen: false,
  translations: {},
  tabsList: [
    MainSource.Home,
    MainSource.SiteFiles,
    MainSource.VisitorsUploads,
    MainSource.Favorites,
    MainSource.Trash,
    MainSource.MediaFromWix,
    MainSource.Shutterstock,
    MainSource.ShutterstockVideo,
    MainSource.Unsplash,
    MainSource.Recommended,
  ],
  servicesList: [
    ExternalSource.WixSite,
    ExternalSource.GoogleDrive,
    ExternalSource.Facebook,
    ExternalSource.Instagram,
    ExternalSource.Dropbox,
    ExternalSource.GooglePhotos,
    ExternalSource.Vimeo,
    ExternalSource.Flickr,
    ExternalSource.DeviantArt,
    ExternalSource.Dribbble,
    ExternalSource.Link,
  ],
  sort: Sort.LastModified,
  layout: SettingsLayout.GalleryWithPanel,
  selectionType: Selection.Multiple,
  mediaType: join(',', [
    MediaType.Picture,
    MediaType.SiteIcon,
    MediaType.Video,
    MediaType.Music,
    MediaType.Document,
    MediaType.VectorArt,
    MediaType.Zip,
    MediaType.SWF,
  ]),
  namespace: NameSpace.None,
  vision: ['label', 'face'],
  maxParallelUploads: 4,
  videoEncodingProfile: 'mp4-only',
  useFastTranscoding: false,
  alwaysShowAddMediaContributorsHint: false,
  alwaysShowUploadingContributorsHint: false,
  initialMediaTypes: [],
  restrictContent: false,
  restrictK12: false,
  mimeTypesAllowed: [],
};
